// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-nav-buttons {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 100;
}

:root[data-profile-menu-open='true'] .article-nav-buttons {
  display: none !important;
}

.nav-btn {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  color: var(--text-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 0;
  font-size: 0.7rem;
  font-weight: 600;
  flex-direction: column;
  gap: 2px;
}

.nav-btn svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.nav-btn span {
  font-size: 0.6rem;
  line-height: 1;
  white-space: nowrap;
}

.nav-btn:hover {
  background: var(--accent-primary);
  color: var(--text-primary);
  border-color: var(--accent-primary);
  transform: translateY(-4px) translateX(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.nav-btn:active {
  transform: translateY(-2px) translateX(-2px);
}

/* Mobile: adjust sizing on smaller screens */
@media (max-width: 1400px) {
  .article-nav-buttons {
    right: 12px;
  }

  .nav-btn {
    width: 44px;
    height: 44px;
  }

  .nav-btn svg {
    width: 18px;
    height: 18px;
  }

  .nav-btn span {
    font-size: 0.55rem;
  }
}

/* Accessibility: reduce motion */
@media (prefers-reduced-motion: reduce) {
  .nav-btn {
    transition: none;
  }

  .nav-btn:hover {
    transform: translateY(-50%);
  }
}

/* Dark theme support */
[data-theme="dark"] .nav-btn {
  background: var(--bg-secondary);
  border-color: var(--border-color);
}

[data-theme="dark"] .nav-btn:hover {
  background: var(--accent-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/ArticleNavButtons/ArticleNavButtons.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yCAAyC;EACzC,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,mCAAmC;EACnC,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,6CAA6C;AAC7C;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,uBAAuB;AACvB;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".article-nav-buttons {\r\n  position: fixed;\r\n  right: 20px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  z-index: 100;\r\n}\r\n\r\n:root[data-profile-menu-open='true'] .article-nav-buttons {\r\n  display: none !important;\r\n}\r\n\r\n.nav-btn {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  padding: 0;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.nav-btn svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.nav-btn span {\r\n  font-size: 0.6rem;\r\n  line-height: 1;\r\n  white-space: nowrap;\r\n}\r\n\r\n.nav-btn:hover {\r\n  background: var(--accent-primary);\r\n  color: var(--text-primary);\r\n  border-color: var(--accent-primary);\r\n  transform: translateY(-4px) translateX(-4px);\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.nav-btn:active {\r\n  transform: translateY(-2px) translateX(-2px);\r\n}\r\n\r\n/* Mobile: adjust sizing on smaller screens */\r\n@media (max-width: 1400px) {\r\n  .article-nav-buttons {\r\n    right: 12px;\r\n  }\r\n\r\n  .nav-btn {\r\n    width: 44px;\r\n    height: 44px;\r\n  }\r\n\r\n  .nav-btn svg {\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n\r\n  .nav-btn span {\r\n    font-size: 0.55rem;\r\n  }\r\n}\r\n\r\n/* Accessibility: reduce motion */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .nav-btn {\r\n    transition: none;\r\n  }\r\n\r\n  .nav-btn:hover {\r\n    transform: translateY(-50%);\r\n  }\r\n}\r\n\r\n/* Dark theme support */\r\n[data-theme=\"dark\"] .nav-btn {\r\n  background: var(--bg-secondary);\r\n  border-color: var(--border-color);\r\n}\r\n\r\n[data-theme=\"dark\"] .nav-btn:hover {\r\n  background: var(--accent-primary);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
